import React, { useState, useEffect } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Button,
  IconButton,
  Divider,
  TextField,
  Autocomplete,
} from "@mui/material";
import { getData, postData } from "../../../ServerRequest";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import GridViewIcon from "@mui/icons-material/GridView";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
//import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
//import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
//import MenuIcon from "@mui/icons-material/Menu";
//import AddIcon from "@mui/icons-material/Add";
//import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";

const buttonStyle = {
  background: "#f8f9fa",
  border: "3px solid #b0bec5",
  color: "black",
  fontSize: "0.850rem",
  "&:hover": { background: "#eceff1" },
  fontFamily: "Inter, sans-serif",
};

const sectionStyle = {
  backgroundColor: "rgba(255, 255, 255, 0.6)",
  marginBottom: 2,
  boxShadow: "0px 4px 8px rgba(0, 0, 1, 0.1)",
  fontFamily: "Inter, sans-serif ",
};

const inputStyle = {
  "& .MuiInputBase-root": {
    height: "35px",
    borderRadius: "0",
    backgroundColor: "white",
    fontFamily: "Inter, sans-serif",
  },
};

export default function LandingPageFabric() {
  const [loading, setLoading] = useState(false);
  const [fabrics, setFabrics] = useState([]);
  //const [fabricTiles, setFabricTiles] = useState([]);
  const [previewImage, setPreviewImage] = useState(null);
  //const [editingIndex, setEditingIndex] = useState(null);
  const [collectionOptions, setCollectionOptions] = useState([]);

  const handleFabricsSubmit = async (index) => {
    let fabric = fabrics[index];
    let fabricReqData = {
      'id': fabric.id ? fabric.id : "",
      'title': fabric.title ? fabric.title : "",
      'subheading': fabric.subheading ? fabric.subheading : "",
      'orientation_number': fabric.orientation_number ? fabric.orientation_number : "",
      'page_link': fabric.page_link ? fabric.page_link : "",
      'collection_name': fabric.collection_name ? fabric.collection_name : "",
    };

    // Convert image file to base64 if present
    const convertToBase64 = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    };
    if (fabric.fabric_image_file) {
      fabricReqData.fabric_image = await convertToBase64(fabric.fabric_image_file);
    }

    try {
      let fabricsResData = await postData(
        "/api/theme/landing_fabric",
        fabricReqData
      );
      if (fabricsResData["data"]["code"] !== 200) {
        alert("Fabrics saved successfully");
      } else {
        alert("Error saving fabrics data");
        setLoading(false);
      }
      return false;
    } catch (error) {
      console.error("Error in saving fabric:", error);
    }
  };

  useEffect(() => {
    async function fetchData() {
      let resData = await getData("/api/theme/landing_fabric?is_admin=true");
      console.log(resData);
      let fabrics_data = resData["data"]["fabrics"];
      if (fabrics_data) {
        // Ensure collection and page_link values are properly set
        const updatedFabrics = fabrics_data.map((fabric) => ({
          ...fabric,
          collection: fabric.collection?.id || "", // Set collection ID or empty string
          page_link: fabric.page_link || "", // Set page_link or empty string
        }));
        setFabrics(updatedFabrics);
      } else {
        console.error("Error fetching fabrics data:", resData.message);
      }

      let collectionResData = await getData("/api/product/product-collection");
      console.log(collectionResData);
      let collections_data = collectionResData["data"]["live_collections"];
      if (collections_data) {
        const formattedCollections = collections_data.map((collection) => ({
          label: collection.collection || "",
          value: collection.id || "",
          collection_url: collection.collection_url || "",
        }));
        setCollectionOptions(formattedCollections); // Ensure collectionOptions is set correctly
      } else {
        console.error(
          "Error fetching collection data:",
          collectionResData.message
        );
      }

      setLoading(false);
    }

    fetchData();
  }, []);

  const handleImageUpload = (e, index) => {
    const file = e.target.files[0];
    if (file) {
      const img = new window.Image();
      const imageUrl = URL.createObjectURL(file);
      img.src = imageUrl;
      img.onload = () => {
        if (img.width === 1440 && img.height === 600) {
          setPreviewImage(imageUrl);
          const newFabrics = [...fabrics];
          newFabrics[index].fabric_image = imageUrl;
          newFabrics[index].fabric_image_file = file; // Store file for base64 conversion
          setFabrics(newFabrics);
        } else {
          alert("Image must be exactly 1440px wide and 600px tall.");
        }
      };
    }
  };

  const handleSubheadingChange = (e, index) => {
    let newFabric = [...fabrics];
    newFabric[index].subheading = e.target.value;
    setFabrics(newFabric);
  };

  const handleTitleChange = (e, index) => {
    let newFabric = [...fabrics];
    newFabric[index].title = e.target.value;
    setFabrics(newFabric);
  };

  const handleLinkChange = (event, newValue, index) => {
    const updatedFabrics = [...fabrics];
    if (newValue?.value === "none") {
      updatedFabrics[index].collection = ""; // Clear the collection ID
      updatedFabrics[index].collection_url = ""; // Clear the URL
      updatedFabrics[index].collection_name = "";
      updatedFabrics[index].page_link = ""; // Clear the collection when "None" is selected
      updatedFabrics[index].isEditable = true; // Enable the text field
    } else {
      updatedFabrics[index].collection = newValue?.value || ""; // Update the collection ID
      updatedFabrics[index].collection_url = newValue?.collection_url || ""; // Update the URL to the selected collection's collection_url
      updatedFabrics[index].collection_name = newValue?.label || ""; // Update the collection name
      updatedFabrics[index].page_link = newValue?.collection_url || ""; // Set page_link to the selected collection's collection_url
      updatedFabrics[index].isEditable = false; // Disable the text field
    }
    setFabrics(updatedFabrics);
  };

  const handleURLChange = (e, index) => {
    const newFabric = [...fabrics];
    newFabric[index].page_link = e.target.value;
    setFabrics(newFabric);
  };

  /* const handleAddTile = () => {
    setFabrics([
      ...fabrics,
      { title: "", subheading: "", page_link: "", fabric_image: "" },
    ]);
  };

  const handleEditTile = (e, index) => {
    e.stopPropagation();
    setEditingIndex(index);
  };

  const handleDeleteTile = (e, index) => {
    e.stopPropagation();
    const updatedTiles = fabricTiles.filter((_, i) => i !== index);
    setFabricTiles(updatedTiles);
  }; */

  return (
    <Accordion sx={sectionStyle}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <IconButton color="" component="icon">
            <GridViewIcon />
          </IconButton>
          <Typography variant="h7">Special Fabrics</Typography>
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        {loading ? (
          <Typography>Loading...</Typography>
        ) : (
          <>
            <Typography sx={{ marginBottom: 2, color: "#424956", fontFamily: "Inter", fontWeight: 700, fontSize: 14 }}>Section Tiles</Typography>
            {fabrics.length > 0 ? (
              fabrics.map((tile, index) => (
                <Accordion
                  key={tile}
                  sx={{
                    backgroundColor: "#eceff1",
                    marginBottom: 2,
                    borderRadius: 0,
                    boxShadow: 0,
                  }}
                >
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography
                      sx={{ display: "flex", alignItems: "center", gap: 2 }}
                    >
                      {/* <MenuIcon sx={{ cursor: 'pointer', marginRight: 2 }} /> */}
                      <Box
                        component="img"
                        src={tile.fabric_image}
                        sx={{
                          width: 60,
                          height: 40,
                          objectFit: "cover",
                          borderRadius: 0,
                          marginRight: 2,
                        }}
                      />
                      <Typography>Special Fabric {tile.title}</Typography>
                    </Typography>
                    {/*<div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 1 }}>
                                <IconButton sx={{ mr: 2, color: 'grey' }} onClick={(e) => handleEditTile(e, index)}><EditOutlinedIcon /></IconButton>
                                <IconButton sx={{ color: 'red' }} onClick={(e) => handleDeleteTile(e, index)}><DeleteOutlinedIcon /></IconButton>
                            </div>*/}
                  </AccordionSummary>
                  <AccordionDetails sx={{ padding: 5, pt: 2 }}>
                    <div style={{ display: "flex", alignItems: "center", marginBottom: 2, }}>
                      <Box sx={{ display: "flex", alignItems: "center" }}>                        
                        <Box
                          component="img"
                          src={tile.fabric_image || previewImage}
                          sx={{
                            width: 140,
                            height: 70,
                            objectFit: "cover",
                            borderRadius: 0,
                            marginRight: 2,
                            marginLeft: 2,
                          }}
                        />
                        <div>
                          <IconButton sx={{ color: "black" }} component="label">
                            <FileUploadOutlinedIcon />
                            <input
                              type="file"
                              hidden
                              accept="image/png"
                              onChange={(e) => handleImageUpload(e, index)}
                            />
                          </IconButton>
                        </div>
                      </Box>
                    </div>
                    <Typography variant="caption" sx={{ marginLeft: 2 }} style={{ fontSize: 12, fontFamily: "Inter", fontWeight: 500 }}>
                      W 1440px / H 600px
                    </Typography>
                    <Typography variant="body1" sx={{ color: "#424956", fontFamily: "Inter", fontWeight: 700, fontSize: 14, mt: 3 }}>
                      Title
                    </Typography>
                    <TextField
                      fullWidth                      
                      placeholder="Write title text here"
                      sx={{ ...inputStyle, mb: 1 }}
                      helperText="Max 10 characters including space"
                      variant="outlined"           
                      value={tile.title}
                      onChange={(e) => handleTitleChange(e, index)}
                    />
                    <Typography variant="body1" sx={{ color: "#424956", fontFamily: "Inter", fontWeight: 700, fontSize: 14,  }}>
                      Subheading
                    </Typography>
                    <TextField
                      fullWidth                    
                      placeholder="Write text here"
                      sx={{ ...inputStyle, mb: 1 }}
                      helperText="Max 40 characters including space"
                      variant="outlined"              
                      value={tile.subheading}
                      onChange={(e) => handleSubheadingChange(e, index)}
                    />
                    <Typography variant="body1" sx={{ color: "#424956", fontFamily: "Inter", fontWeight: 700, fontSize: 14,  }}>
                      Link collection page
                    </Typography>
                    <Autocomplete
                      options={[
                        { label: "None", value: "none" },
                        ...collectionOptions, // Use the properly set collectionOptions
                      ]}
                      getOptionLabel={(option) => option.label || ""}
                      value={
                        [collectionOptions].find(
                          (option) => 
                            option.value === tile.collection ||
                            option.label === tile.collection_name
                        ) || {
                          label: tile.collection_name || "None",
                          value: tile.collection || "none",
                          collection_url: tile.collection_url || "",
                        }
                      }
                      onChange={(event, newValue) =>
                        handleLinkChange(event, newValue, index)
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}                          
                          fullWidth
                          sx={{
                            ...inputStyle,
                            marginBottom: 2,
                            mr: 11,
                          }}
                        />
                      )}
                    />
                    <Divider sx={{ margin: 0 }}>OR</Divider>
                    <Typography variant="body1" sx={{ color: "#424956", fontFamily: "Inter", fontWeight: 700, fontSize: 14,  }}>
                      URL to link collection page
                    </Typography>
                    <TextField
                      fullWidth                      
                      placeholder="URL"
                      variant="outlined"                      
                      sx={{ ...inputStyle, mb: 2 }}                      
                      value={tile.page_link}
                      onChange={(e) => handleURLChange(e, index)}
                      disabled={!tile.isEditable}
                    />
                    <Button
                      onClick={() => handleFabricsSubmit(index)}
                      sx={{ ...buttonStyle, mt: 2 }}
                    >
                      Save
                    </Button>
                  </AccordionDetails>
                </Accordion>
              ))
            ) : (
              <Typography>No fabrics available</Typography>
            )}
            {/*<IconButton variant="contained" sx={{ ...buttonStyle, mt: 1 }} onClick={handleAddTile}>
                    <AddIcon />
                </IconButton>*/}
          </>
        )}
      </AccordionDetails>
    </Accordion>
  );
}
